import { grpc, someGrpc } from "@somewear/grpc";
import { actionSetEpicHandlerBuilder } from "@somewear/model";
import { combineEpics } from "redux-observable";

import { workspaceSettingsActions } from "./workspaceSettings.slice";

const updateDefaultSettingsEpic = actionSetEpicHandlerBuilder(
	workspaceSettingsActions.updateDefaultSettings,
	(payload) =>
		grpc.prepareRequestWithPayload(someGrpc.updateWorkspaceDefaultSettings, payload.data),
	() => {
		return {
			onFulfilled: "Successfully updated workspace default settings",
			onPending: "",
			onRejected: "Failed to update workspace default settings",
		};
	},
);

const getDefaultSettingsEpic = actionSetEpicHandlerBuilder(
	workspaceSettingsActions.getDefaultSettings,
	(payload) => grpc.prepareRequestWithPayload(someGrpc.getWorkspaceDefaultSettings, payload.data),
);

export const workspaceSettingsEpics = combineEpics<any, any, any>(
	updateDefaultSettingsEpic,
	getDefaultSettingsEpic,
);
